import React, { useContext } from "react"
import EscapeRoomData from "../EscaperoomsPage/components/EscapeRoomData"
import { Helmet } from "react-helmet"
import { useParams } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faPlayCircle } from "@fortawesome/free-solid-svg-icons"
import { AppContext } from "../shared/context/AppContext"
import PageNotFound from "../PageNotFound/PageNotFound"
import "./PaymentComplete.css"

function PaymentComplete() {
  const { language } = useContext(AppContext)
  const nl = language === "NL"
  const { orderId, ERid } = useParams()
  const room = EscapeRoomData.find((x) => x.id === ERid)

  // An old or mistyped link
  if (!room) {
    return <PageNotFound />
  }

  const { title, titleEN, URL, themeColor, id } = room
  const name = nl ? title : titleEN

  return (
    <main className="page payment-complete">
      <style>
        {`.${id}-background-color {background-color: ${themeColor};}`}
      </style>
      <Helmet>
        <title>{nl ? "Bevestiging" : "Confirmation"} | Escape Mystery</title>
      </Helmet>

      <div className="page-content narrow">
        <div className="complete-card">
          <span className="complete-check" aria-hidden="true">
            <FontAwesomeIcon icon={faCheck} />
          </span>
          <h1>{nl ? "Bedankt voor je bestelling!" : "Thanks for your order!"}</h1>
          <p className="complete-order">
            {nl ? "Ordernummer" : "Order number"}: <strong>{orderId}</strong>
          </p>
          <p>
            {nl
              ? `Binnen 10 minuten krijg je een e-mail met de toegangscode voor ${title}. Daarmee kun je direct inloggen en jullie avontuur beginnen. Heel veel plezier!`
              : `Within 10 minutes you'll get an e-mail with the access code for ${titleEN}. You can log in with it right away and start your adventure. Have fun!`}
          </p>
          <a
            href={URL}
            target="_blank"
            rel="noreferrer"
            className={`blue-button ${id}-background-color complete-play`}
          >
            <FontAwesomeIcon icon={faPlayCircle} />
            {nl ? `Naar ${name}` : `Go to ${name}`}
          </a>
        </div>

        <div className="complete-help">
          <h2>{nl ? "Geen e-mail ontvangen?" : "No e-mail?"}</h2>
          <p>
            {nl
              ? "Kijk eerst even in je spam of ongewenste e-mail. Staat hij daar ook niet? Mail dan naar "
              : "First check your spam or junk folder. Not there either? E-mail "}
            <a href="mailto:helpdesk@escapemystery.nl">
              helpdesk@escapemystery.nl
            </a>
            {nl
              ? ` en noem je ordernummer (${orderId}).`
              : ` and mention your order number (${orderId}).`}
          </p>
        </div>
      </div>
    </main>
  )
}

export default PaymentComplete
